﻿import TaxonomyList from "./TaxonomyList"

export default class ContactPeopleTaxonomyList extends TaxonomyList {
    static init (querySelector = '.contact-people-list[data-source-id]') {
        Array.prototype.forEach.call(document.querySelectorAll(querySelector), element => {
            new ContactPeopleTaxonomyList(element)})
    }
    
    render (containerElement, groupsToRender) {
        var itemIndex = 0
        containerElement.innerHTML = ''
        groupsToRender.forEach((group) => {
            if (this.groupBy === 'True') {
                if (this.showGroupsCondensed === 'False') {
                    var groupElement = document.createElement("li")
                    groupElement.classList.add('col-12')
                    groupElement.innerHTML =
                        `<h3 class="contact-person-heading">
                        ${group.GroupLabel ? group.GroupLabel : ''}
                    </h3>`;

                    containerElement.appendChild(groupElement)
                }
                else if (this.showGroupsCondensed === 'True') {
                    containerElement.classList.add('display-condensed')
                }
            }

            group.Items.forEach((item) => {
                itemIndex++

                var itemElement = document.createElement("li")
                itemElement.classList.add('col-6')

                itemElement.style.opacity = itemIndex >= this.totalNumber ? 0 : 1
                itemElement.style.transition = `opacity 500ms ease-in`

                if (this.groupBy !== 'False' && group.GroupLabel) {
                   itemElement.classList.add(group.GroupLabel.replace(' ', '-'));
                }

                itemElement.innerHTML =
                    (`<div class="contact-person-item">
                                 ${this.groupBy === 'True' && this.showGroupsCondensed === 'True' ? `<h3 class="contact-person-heading">${group.GroupLabel ? group.GroupLabel : ''}</h3>` : ''}
                    ${item.ProfileHeading && this.groupBy !== 'True' ? `<h3 class="contact-person-heading">${item.ProfileHeading}</h3>` : ''}
                        
                    <div class="contact-person-item-inner d-flex flex-column flex-md-row">
                        ${(item.PortraitPhoto) ? `<div class="contact-person-image">${item.PortraitPhoto}</div>` : ''}

                        <div class="contact-person-information">

                            <h2 class="contact-person-name">
                                ${(item.ProfileLink) ? `<a href="${item.ProfileLink}">${item.Firstname} ${item.Surname}</a>` : `${item.Firstname} ${item.Surname}`}
                            </h2>

                            ${(item.JobPosition) ? `<div class="contact-person-position">${item.JobPosition}</div>` : ''}
                            ${(item.ProfileText) ? `<div class="contact-person-text">${item.ProfileText}</div>` : ''}
                            ${(item.PhoneNumber) ? `<div class="contact-person-phone-number">${item.PhoneNumber}</div>` : ''}
                            ${(item.EmailAddress) ? `<a class="contact-person-email" href="mailto:${item.EmailAddress}">${item.EmailAddress}</a>` : ''}
                            ${(item.LinkedInProfileLink) ? `<a class="contact-person-linkedin" href="${item.LinkedInProfileLink}" target="_blank">LinkedIn</a>` : ''}
                        </div>
                    </div>
                </div>`);

                containerElement.appendChild(itemElement)

                setTimeout(() => {
                    itemElement.style.opacity = 1
                    var imgForUpdate = itemElement.querySelector('img');
                    if (imgForUpdate !== null && imgForUpdate !== 'undefined') {
                        window.bLazy.load(itemElement.querySelector('img'), true);
                    }

                    if (itemElement.nextElementSibling !== null && this.groupBy === 'True' && this.showGroupsCondensed === 'True') {
                        if (itemElement.className !== itemElement.nextElementSibling.className) {
                            itemElement.setAttribute('data-last-in-group', 'True')
                        }
                    }
                    if (itemElement.previousElementSibling !== null && this.groupBy === 'True' && this.showGroupsCondensed === 'True') {
                        if (itemElement.className !== itemElement.previousElementSibling.className) {
                            itemElement.setAttribute('data-first-in-group', 'True')
                        }
                    }
                }, itemIndex >= this.totalNumber ? ~~(Math.sqrt(itemIndex) * 115) : 0)
            })
        })
    }
}